/* eslint-disable no-undef */
import { Certificates } from './certificates'
import axios from 'axios'

export class Signer {
  constructor ({ requestHashUrl, sendSignatureUrl, certListBoxId, stringConstructor, statusSettings = {} }) {
    this.requestHashUrl = requestHashUrl
    this.sendSignatureUrl = sendSignatureUrl
    this.certListBoxId = certListBoxId
    this.stringConstructor = stringConstructor

    this.certSubjectName = null
    this.hashAlgorithm = null

    this.certificate = null
    this.certificates = []
    this.Certificates = null

    this.statusSettings = statusSettings

    // @fixme тут надо указать нормальный адрес TSP сервера. Это тестовый от Крипто ПРО
    this.TSAAddress = 'http://testca.cryptopro.ru/tsp/tsp.srf'
  }

  async requestCertificates () {
    if (!this.Certificates) {
      this.Certificates = new Certificates({
        certListBoxId: this.certListBoxId,
        stringConstructor: this.stringConstructor,
        Signer: this
      })
    }
  }

  async sign () {
    if (!window.cadesplugin) {
      alert('Не получилось загрузить плагин КриптоПро ЭЦП. Подпись недоступна')
      return false
    }

    const certListBox = document.querySelector(`#${this.certListBoxId}`)
    this.certSubjectName = certListBox.value
    if (!this.certSubjectName) {
      alert('Выберите сертификат для подписи')
      return false
    }

    this.certificate = this.getCertificate()
    if (!this.certificate) {
      alert('Не удалось получить сертификат')
      return false
    }

    this.hashAlgorithm = await this.getHashAlgorithm()
    if (!this.hashAlgorithm) {
      alert('Невозможно подписать документ этим сертификатом')
      return false
    }

    const hashData = await this.requestHash()
    const tempId = hashData.data.id
    const hashValue = hashData.data.hash
    const signatureNumber = hashData.data.current
    this.position = hashData.data.next ? hashData.data.next : undefined
    if (!hashValue) {
      alert('Неверные данные')

      return false
    }
    const sign = await this.generateSignature(hashValue)

    await this.sendSignature(tempId, sign, signatureNumber)
    if (this.position !== null && this.position !== undefined) {
      await this.sign()
    }

    return true
  }

  getCertificate () {
    return this.certificates[this.certSubjectName]
  }

  async getHashAlgorithm () {
    const certPublicKey = await this.certificate.PublicKey()
    const certAlgorithm = await certPublicKey.Algorithm
    const algorithmValue = await certAlgorithm.Value

    if (algorithmValue === '1.2.643.7.1.1.1.1') {
      return window.cadesplugin.CADESCOM_HASH_ALGORITHM_CP_GOST_3411_2012_256
    } else if (algorithmValue === '1.2.643.7.1.1.1.2') {
      return window.cadesplugin.CADESCOM_HASH_ALGORITHM_CP_GOST_3411_2012_512
    } else if (algorithmValue === '1.2.643.2.2.19') {
      return window.cadesplugin.CADESCOM_HASH_ALGORITHM_CP_GOST_3411
    } else {
      alert('Неподдерживаемый алгоритм ключа - ' + algorithmValue)
      return false;
    }

    return false
  }

  requestHash () {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve, reject) => {
      await axios.post(this.requestHashUrl, {
        position: this.position,
        algorithm: this.hashAlgorithm,
        number: await this.certificate.SerialNumber,
        from: await this.certificate.ValidFromDate,
        to: await this.certificate.ValidToDate,
        owner: await this.certificate.SubjectName,
        stamp_position: this.statusSettings
      }).then(resolve).catch(reject)
    })
  }

  sendSignature (id, sign, signatureNumber) {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve, reject) => {
      await axios.post(this.sendSignatureUrl, {
        id: id,
        sign: sign,
        stamp_position: this.statusSettings,
        current: signatureNumber
      }).then(resolve).catch(reject)
    })
  }

  async generateSignature (hashValue) {
    const oSigner = await window.cadesplugin.CreateObjectAsync('CAdESCOM.CPSigner')
    oSigner.propset_Certificate(this.certificate)
    oSigner.propset_Options(window.cadesplugin.CAPICOM_CERTIFICATE_INCLUDE_WHOLE_CHAIN)

    const hashObject = await window.cadesplugin.CreateObjectAsync('CAdESCOM.HashedData')
    hashObject.propset_Algorithm(this.hashAlgorithm)
    hashObject.SetHashValue(hashValue)

    // Задание типа подписи
    const cades = window.cadesplugin.CADESCOM_CADES_BES

    const oSignedData = await window.cadesplugin.CreateObjectAsync('CAdESCOM.CadesSignedData')
    oSignedData.propset_ContentEncoding(window.cadesplugin.CADESCOM_BASE64_TO_BINARY)
    const signatureHex = await oSignedData.SignHash(hashObject, oSigner, cades)

    // Проверяем подпись
    var oSignedData2 = await window.cadesplugin.CreateObjectAsync('CAdESCOM.CadesSignedData')
    try {
      await oSignedData2.VerifyHash(hashObject, signatureHex, cades)
    } catch (err) {
      console.error(err)
      alert('Ошибка при верификации подписи')
    }

    return signatureHex
  }
}
